
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalNotification as ObiBatteryVerticalNotificationElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-notification.js';
 
 
 

 
 export const ObiBatteryVerticalNotification = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-notification',
   elementClass: ObiBatteryVerticalNotificationElement,
   events: {
     
   }
  });
 
 